if (!customElements.get('subscription-gift-handler')) {
  customElements.define(
    'subscription-gift-handler',
    class SubscriptionGiftHandler extends HTMLElement {
      constructor() {
        super();
        
        this.SUBSCRIPTION_PRODUCT_ID = window.subscriptionGiftSettings?.subscriptionProductId || '7722874798131';
        this.FREE_GIFT_PRODUCT_ID = window.subscriptionGiftSettings?.giftProductId || '7723756683315';
        this.FREE_GIFT_PRODUCT_HANDLE = window.subscriptionGiftSettings?.giftProductHandle || 'bonus-shaker-bottle';
        this.ENABLED = window.subscriptionGiftSettings?.enabled !== false;
        
        this.subscriptionWidget = null;
        this.isSubscriptionSelected = false;
        this.currentQuantity = 1;
        this.isAddingBanner = false;
        
        this.init();
      }

      init() {
        if (!this.ENABLED) return;
        
        if (window.productData && window.productData.id.toString() === this.FREE_GIFT_PRODUCT_ID) {
          this.disableGiftProductPurchase();
          return;
        }
        


        this.waitForRechargeWidget();
        this.observeQuantityChanges();
      }

      disableGiftProductPurchase() {
        const productForm = document.querySelector('product-form');
        if (!productForm) return;

        const submitButton = productForm.querySelector('[type="submit"]');
        const errorMessageWrapper = productForm.querySelector('.product-form__error-message-wrapper');
        const errorMessage = productForm.querySelector('.product-form__error-message');

        if (submitButton) {
          submitButton.setAttribute('disabled', 'disabled');
          submitButton.setAttribute('aria-disabled', 'true');
          const buttonText = submitButton.querySelector('span');
          if (buttonText) {
            buttonText.textContent = 'Not Available for Purchase';
          }
        }

        if (errorMessageWrapper && errorMessage) {
          errorMessage.textContent = 'This item is only available as a gift with subscription purchases.';
          errorMessageWrapper.removeAttribute('hidden');
        }
      }

      waitForRechargeWidget() {
        const checkWidget = setInterval(() => {
          this.subscriptionWidget = document.querySelector('recharge-subscription-widget');
          
          if (this.subscriptionWidget) {
            clearInterval(checkWidget);
            this.attachRechargeListeners();
          }
        }, 100);

        setTimeout(() => clearInterval(checkWidget), 10000);
      }

      attachRechargeListeners() {
        const observer = new MutationObserver((mutations) => {
          this.checkSubscriptionState();
          setTimeout(() => this.ensureGiftBannerExists(), 200);
          setTimeout(() => this.ensureServingInfoExists(), 200);
          setTimeout(() => this.highlightPercentage(), 200);
        });

        observer.observe(this.subscriptionWidget, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['rc-selected']
        });

        this.checkSubscriptionState();
        
        setTimeout(() => {
          this.addGiftBanner();
          this.addServingInfo();
          this.highlightPercentage();
        }, 300);

        setInterval(() => {
          if (!this.isAddingBanner && !this.findExistingBanner()) {
            const targetContainer = this.findTargetContainer();
            if (targetContainer) {
              this.addGiftBanner();
            }
          }
          if (!this.findExistingServingInfo()) {
            this.addServingInfo();
          }
          this.highlightPercentage();
        }, 1000);
      }

      findTargetContainer() {
        const subContainer = this.subscriptionWidget.querySelector('.rc-purchase-option__sub-container');
        
        if (subContainer) return subContainer;
        
        if (this.subscriptionWidget.shadowRoot) {
          const shadowContainer = this.subscriptionWidget.shadowRoot.querySelector('.rc-purchase-option__sub-container');
          if (shadowContainer) return shadowContainer;
        }
        
        return null;
      }

      ensureGiftBannerExists() {
        if (this.isAddingBanner) return;
        if (this.findExistingBanner()) return;

        const targetContainer = this.findTargetContainer();
        if (targetContainer) {
          this.addGiftBanner();
        }
      }

      findExistingBanner() {
        if (document.getElementById('subscription-gift-banner')) {
          return true;
        }

        if (this.subscriptionWidget.shadowRoot) {
          const shadowBanner = this.subscriptionWidget.shadowRoot.getElementById('subscription-gift-banner');
          if (shadowBanner) return true;
        }

        const widgetBanner = this.subscriptionWidget.querySelector('#subscription-gift-banner');
        if (widgetBanner) return true;

        return false;
      }

      findExistingServingInfo() {
        if (document.querySelector('.rc-serving-info')) {
          return true;
        }

        if (this.subscriptionWidget.shadowRoot) {
          const shadowInfo = this.subscriptionWidget.shadowRoot.querySelector('.rc-serving-info');
          if (shadowInfo) return true;
        }

        const widgetInfo = this.subscriptionWidget.querySelector('.rc-serving-info');
        if (widgetInfo) return true;

        return false;
      }

      ensureServingInfoExists() {
        if (this.findExistingServingInfo()) return;
        this.addServingInfo();
      }

      findLabelElement() {
        let labelElement = this.subscriptionWidget.querySelector('.rc-purchase-option__subscription .rc-purchase-option__label');
        
        if (labelElement) return labelElement;
        
        if (this.subscriptionWidget.shadowRoot) {
          const shadowLabel = this.subscriptionWidget.shadowRoot.querySelector('.rc-purchase-option__subscription .rc-purchase-option__label');
          if (shadowLabel) return shadowLabel;
        }
        
        return null;
      }

      addServingInfo() {
        if (this.findExistingServingInfo()) return;

        const labelElement = this.findLabelElement();
        
        if (!labelElement) return;

        const servingInfoHTML = `
          <div class="rc-serving-info rc-purchase-option__label" style="
            display: flex;
            gap: 8px;
            align-items: center;
            justify-content: space-between;
            padding-top: 0 !important;
            padding-bottom: 8px !important;
          ">
            <span style="
              font-family: 'Bebas Neue', sans-serif;
              font-size: 20px;
              color: #343A40;
            ">30 Servings</span>
            <span style="
              font-family: 'Bebas Neue', sans-serif;
              font-size: 20px;
              color: #343A40;
            ">$1.33 / Per Stick</span>
          </div>
        `;

        labelElement.insertAdjacentHTML('afterend', servingInfoHTML);
      }

      highlightPercentage() {
        if (!this.subscriptionWidget) return;

        const selectors = [];
        
        selectors.push(...this.subscriptionWidget.querySelectorAll('.rc-purchase-option__selector'));
        
        if (this.subscriptionWidget.shadowRoot) {
          selectors.push(...this.subscriptionWidget.shadowRoot.querySelectorAll('.rc-purchase-option__selector'));
        }

        const percentageRegex = /(\d+\.?\d*%)/g;
        
        selectors.forEach(selector => {
          if (selector.hasAttribute('data-percentage-highlighted')) return;
          
          const walker = document.createTreeWalker(selector, NodeFilter.SHOW_TEXT);
          
          const textNodes = [];
          let node;
          while (node = walker.nextNode()) {
            textNodes.push(node);
          }
          
          textNodes.forEach(textNode => {
            if (percentageRegex.test(textNode.textContent)) {
              const wrapper = document.createElement('span');
              wrapper.innerHTML = textNode.textContent.replace(percentageRegex, '<span class="percentage-highlight">$1</span>');
              textNode.replaceWith(wrapper);
            }
          });
          
          selector.setAttribute('data-percentage-highlighted', 'true');
        });
      }

      async addGiftBanner() {
        if (this.isAddingBanner) {
          return;
        }
        if (this.findExistingBanner()) {
          return;
        }

        this.isAddingBanner = true;

        try {
          const giftHandle = this.FREE_GIFT_PRODUCT_HANDLE;
          const productResponse = await fetch(`/products/${giftHandle}.js`);
          const giftProduct = await productResponse.json();

          const targetContainer = this.findTargetContainer();

          if (!targetContainer) {
            this.isAddingBanner = false;
            return;
          }
          
          if (this.findExistingBanner()) {
            this.isAddingBanner = false;
            return;
          }

          const price = giftProduct.price / 100;
          const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format(price);

          const imageUrl = giftProduct.featured_image || (giftProduct.images && giftProduct.images[0]);

          const bannerHTML = `
            <div id="subscription-gift-banner" style="
              margin-top: 16px;
              padding: 0 20px 20px;
              
            ">
              <div style="
                display: flex;
            align-items: center;
                gap: 16px;
                background: #F0F0F0;
                border-radius: 14px;
                padding: 10px 7px 10px 24px;
              ">
                <div style="
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  gap: 6px;
                ">
<div style="
  font-family: 'Bebas Neue', sans-serif;
  font-size: 30px;
  font-weight: 400;
  color: #F4A100;
  letter-spacing: 0.5px;
  line-height: 1;
  margin-bottom: 4px;
">
  FREE CREWFUEL SHAKER!
</div>

<div style="
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #343A40;
">
  Included with your first subscription order.
</div>
                  </div>
                ${imageUrl ? `
                  <div>
                    <img src="${imageUrl}" alt="${giftProduct.title}" style="
                      width: 100px;
                      height: 100px;
                      object-fit: contain;
                    ">
                  </div>
                ` : ''}
              </div>
            </div>
          `;

          targetContainer.insertAdjacentHTML('afterend', bannerHTML);
        } catch (error) {
          console.error('Error adding gift banner:', error);
        } finally {
          this.isAddingBanner = false;
        }
      }

      checkSubscriptionState() {
        const subscriptionOption = this.subscriptionWidget.querySelector('.rc-purchase-option__subscription[rc-selected]');
        const onetimeOption = this.subscriptionWidget.querySelector('.rc-selection__onetime[rc-selected]');
        
        const wasSubscriptionSelected = this.isSubscriptionSelected;
        this.isSubscriptionSelected = subscriptionOption !== null;

        if (this.isSubscriptionSelected && !wasSubscriptionSelected) {
          this.updateGiftInCart('add');
        } else if (!this.isSubscriptionSelected && wasSubscriptionSelected) {
          this.updateGiftInCart('remove');
        }

        this.saveState();
      }

      observeQuantityChanges() {
        const quantityInput = document.querySelector('input[name="quantity"]');
        
        if (quantityInput) {
          this.currentQuantity = parseInt(quantityInput.value) || 1;
          
          quantityInput.addEventListener('change', (e) => {
            const newQuantity = parseInt(e.target.value) || 1;
            
            if (this.isSubscriptionSelected && newQuantity !== this.currentQuantity) {
              this.currentQuantity = newQuantity;
              this.updateGiftInCart('update');
            }
          });

          const minusButton = quantityInput.parentElement.querySelector('button[name="minus"]');
          const plusButton = quantityInput.parentElement.querySelector('button[name="plus"]');
          
          if (minusButton) {
            minusButton.addEventListener('click', () => {
              setTimeout(() => {
                const newQuantity = parseInt(quantityInput.value) || 1;
                if (this.isSubscriptionSelected && newQuantity !== this.currentQuantity) {
                  this.currentQuantity = newQuantity;
                  this.updateGiftInCart('update');
                }
              }, 100);
            });
          }

          if (plusButton) {
            plusButton.addEventListener('click', () => {
              setTimeout(() => {
                const newQuantity = parseInt(quantityInput.value) || 1;
                if (this.isSubscriptionSelected && newQuantity !== this.currentQuantity) {
                  this.currentQuantity = newQuantity;
                  this.updateGiftInCart('update');
                }
              }, 100);
            });
          }
        }
      }

      async updateGiftInCart(action) {
        if (action === 'add' || action === 'update') {
          await this.addGiftToCartWithSync();
        } else if (action === 'remove') {
          await this.removeGiftFromCart();
        }
      }

      async addGiftToCartWithSync() {
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          const existingGiftItem = cart.items.find(item => 
            item.product_id.toString() === this.FREE_GIFT_PRODUCT_ID
          );

          const targetQuantity = this.currentQuantity;

          if (existingGiftItem) {
            if (existingGiftItem.quantity !== targetQuantity) {
              await this.updateGiftQuantity(existingGiftItem.variant_id, targetQuantity);
            }
          } else {
            await this.fetchAndAddGift(targetQuantity);
          }
        } catch (error) {
          console.error('Error adding gift to cart:', error);
        }
      }

      async addGiftToCart() {
        try {
          const productResponse = await fetch(`/products/${this.FREE_GIFT_PRODUCT_HANDLE}.js`);
          const product = await productResponse.json();
          
          if (product.variants && product.variants.length > 0) {
            const variantId = product.variants[0].id;
            
            localStorage.setItem('allowFreeGiftAdd', 'true');
            
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                id: variantId,
                quantity: this.currentQuantity
              })
            });

            if (!response.ok) {
              throw new Error('Failed to add gift');
            }

            return await response.json();
          }
        } catch (error) {
          console.error('Error adding gift:', error);
          throw error;
        }
      }

      async fetchAndAddGift(quantity) {
        try {
          const productResponse = await fetch(`/products/${this.FREE_GIFT_PRODUCT_HANDLE}.js`);
          const product = await productResponse.json();
          
          if (product.variants && product.variants.length > 0) {
            const variantId = product.variants[0].id;
            
            localStorage.setItem('allowFreeGiftAdd', 'true');
            
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', quantity);

            const config = {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            };

            await fetch('/cart/add.js', config);
            
            this.refreshCart();
          }
        } catch (error) {
          console.error('Error fetching gift product:', error);
        }
      }

      async updateGiftQuantity(variantId, quantity) {
        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });

          this.refreshCart();
        } catch (error) {
          console.error('Error updating gift quantity:', error);
        }
      }

      async removeGiftFromCart() {
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          const giftItem = cart.items.find(item => 
            item.product_id.toString() === this.FREE_GIFT_PRODUCT_ID
          );

          if (giftItem) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                id: giftItem.variant_id,
                quantity: 0
              })
            });

            this.refreshCart();
          }
        } catch (error) {
          console.error('Error removing gift from cart:', error);
        }
      }

      refreshCart() {
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { 
            source: 'subscription-gift-handler'
          });
        }

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.refresh === 'function') {
          cartDrawer.refresh();
        }
      }

      saveState() {
        const state = {
          isSubscriptionSelected: this.isSubscriptionSelected,
          quantity: this.currentQuantity,
          timestamp: Date.now()
        };
        
        localStorage.setItem('subscriptionGiftState', JSON.stringify(state));
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  const productPage = document.querySelector('.product');
  if (productPage && !document.querySelector('subscription-gift-handler')) {
    const handler = document.createElement('subscription-gift-handler');
    document.body.appendChild(handler);
  }
});

